import { Controller, FieldValues, UseFormReturn } from "react-hook-form";
import OneOption from "./OneOption";
import InputErrorMsg from "../../form-builder-helpers/InputErrorMsg";
import OptionsDropdown from "@/app/components/common-addons-builder/common-addons-fields/hook-dropdown/options-dropdown/OptionsDropdown";
import { IField } from "@/api/AppApi/services/builder/interfaces/interfaces";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  field: IField;
  form: UseFormReturn<FieldValues, any>;
  isPC?: boolean;
}

const HookSelectOneDropdown: React.FC<Props> = ({
  form,
  field: formField,
  isPC = false,
}) => {
  const fConfig = formField.configurations;
  const { key, value } =
    formField?.data?.find((val) => val.key === form.watch(fConfig.key))! ?? {};
  const t = useTranslation();
  return (
    <div className={`sort-dropdown w-100 ${isPC ? "pc" : ""}`}>
      {!fConfig.hideLabel && (
        <div className="builder-item-label" style={{ marginBottom: 8 }}>
          {fConfig.title}
        </div>
      )}
      <Controller
        name={fConfig.key}
        control={form.control}
        rules={{
          validate: (value) =>
            fConfig.is_required && (!value || value === "-1")
              ? t.this_field_is_required
              : true,
        }}
        render={({ field }) => (
          <OptionsDropdown
            title={value ?? formField.configurations.placeholder ?? ""}
            withBorder
          >
            {formField.data?.map((item) => (
              <OneOption
                key={item.key}
                checked={key?.includes(item.key)}
                onSelect={() => field.onChange(item.key)}
                label={item.value}
              />
            ))}
          </OptionsDropdown>
        )}
      />
      {fConfig.hint && <div className="field-hint">{fConfig.hint}</div>}
      <InputErrorMsg
        errorMsg={form.formState.errors[fConfig.key]?.message as string}
      />
    </div>
  );
};

export default HookSelectOneDropdown;
